import { ArrowRight } from '@mui/icons-material';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem as MUIMenuItem,
  Tooltip
} from '@mui/material';

import clsx from 'clsx';
import { ReactElement, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { MenuItem as IMenuItem } from './MenuItems';

interface Props {
  item: IMenuItem;
  inactive?: boolean;
  inactiveMessage?: string;
}

export default function MenuItem({ item }: Props): ReactElement | null {
  const { pathname } = useLocation();

  const [anchorEl, setAnchorEl] = useState(null);

  if (!item.show()) return null;

  const isInactive = item.disabled || false;

  let message = item.disabledMessage;

  if (item.items && item.items.length > 0) {
    const handleOpen = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
      <>
        <div onClick={handleOpen}>
          <ListItemButton
            className={clsx('navItem', {
              active: item.active?.(pathname),
              inactive: isInactive
            })}
          >
            <ListItemIcon className="icon">{item.icon}</ListItemIcon>
            <ListItemText primary={item.title} />
            <ListItemIcon className="icon" style={{ justifyContent: 'flex-end' }}>
              <ArrowRight />
            </ListItemIcon>
          </ListItemButton>
        </div>
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          className="navigation"
          MenuListProps={{ sx: { padding: 0.5 } }}
        >
          {item.items.map(li => {
            if (!li.show()) return null;

            return li.external ? (
              <a href={li.url} target="_blank" rel="noopener noreferrer" key={li.title}>
                <ListItemButton className="navItem">
                  <ListItemIcon>{li.icon}</ListItemIcon>
                  <ListItemText primary={li.title} />
                </ListItemButton>
              </a>
            ) : (
              <Link to={li.url} key={li.title}>
                <MUIMenuItem onClick={handleClose}>
                  <ListItemIcon>{li.icon}</ListItemIcon>
                  <ListItemText primary={li.title} />
                </MUIMenuItem>
              </Link>
            );
          })}
        </Menu>
      </>
    );
  }
  if (item.external) {
    return (
      <a href={item.url} target="_blank" rel="noopener noreferrer" key={item.title}>
        <ListItemButton className="navItem">
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.title} />
        </ListItemButton>
      </a>
    );
  }
  if (item.url) {
    const toolTip = (
      <Tooltip title={message || ''} placement="right">
        <ListItemButton
          className={clsx('navItem', {
            active: item.active?.(pathname),
            inactive: isInactive
          })}
        >
          <ListItemIcon className="icon">{item.icon}</ListItemIcon>
          <ListItemText primary={item.title} />
        </ListItemButton>
      </Tooltip>
    );
    return !isInactive ? <Link to={item.url}>{toolTip}</Link> : toolTip;
  }

  throw new Error('You need to either specify a URL or a list of items');
}
